import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';

const styles = (theme: Theme) =>
  createStyles({
    inline: {
      // @ts-ignore
      flexDirection: 'row !important',
    },
    label: {
      fontWeight: 500,
      color: theme.palette.primary.main,
    },
  });

interface FormRadioGroupComponentProps extends WithStyles<typeof styles> {
  className?: string;
  labelClass?: string;
  inline?: boolean;
  label?: string | JSX.Element;
  input: JSX.Element;
  onChangeCustom?: (event: React.ChangeEvent<{}>, value: unknown) => void;
}

class FormRadioGroupComponent extends PureComponent<FormRadioGroupComponentProps> {
  static defaultProps = {
    inline: false,
    label: '',
    onChangeCustom: undefined,
  };

  handleChange = (event: React.ChangeEvent<{}>, value: unknown) => {
    const { input, onChangeCustom } = this.props;

    // @ts-ignore
    input.onChange(value);

    if (onChangeCustom) onChangeCustom(event, value);
  };

  render() {
    const { children, classes, className, inline, input, label, labelClass } = this.props;

    return (
      // @ts-ignore
      <FormControl className={className} component="fieldset">
        {/* @ts-ignore */}
        <FormLabel component="legend" className={labelClass}>
          {label}
        </FormLabel>
        <RadioGroup
          aria-label="Timing"
          className={classnames({ [classes.inline]: inline })}
          onChange={this.handleChange}
          {...input}
          // https://github.com/react-dnd/react-dnd/issues/701
          onDrop={(e) => e.preventDefault()}
        >
          {children}
        </RadioGroup>
      </FormControl>
    );
  }
}

export const FormRadioGroup = withStyles(styles)(FormRadioGroupComponent);
